// extracted by mini-css-extract-plugin
module.exports = {"fileStyle":"index_fileStyle__3VQbr","nameShow":"index_nameShow__3q9Zl","uploadTips":"index_uploadTips__7pNc7","errorStyle":"index_errorStyle__6cCqb"};